import { useEffect, useState } from 'react';
import API_URL from '../../apiConfig';

const getImagesArray = (linkImg) => {
    if (!linkImg) return [];
    try {
        const images = typeof linkImg === 'string' ? JSON.parse(linkImg) : linkImg;
        return Array.isArray(images) ? images : [images];
    } catch (e) {
        return [linkImg];
    }
};

function Publier() {
  const [allMedit, setallMedit] = useState([]);
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line
  const [error, setError] = useState("");

  const fetchAllMedit = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/api/meditations/allmeditations`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include"
      });
      const data = await res.json();
      if (data.success && data.meditations) {
        setallMedit(data.meditations.filter(m => Number(m.published) === 1));
      } else {
        setError(data.message || "Impossible de charger les données");
      }
    } catch (err) {
      setError("Erreur serveur lors de la récupération.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllMedit();
  }, []);

  const handleScroll = (id, direction) => {
    const el = document.getElementById(id);
    if (el) {
        const scrollAmount = direction === 'left' ? -el.offsetWidth : el.offsetWidth;
        el.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <div className="container-fluid py-4 animate__animated animate__fadeIn overflow-hidden">
      <div className="d-flex justify-content-between align-items-center mb-4 px-3">
        <h2 className="fw-bold outfit text-dark">✅ Méditations Publiées</h2>
        <div className="d-flex gap-2 align-items-center">
            <span className="badge bg-success px-4 py-2 rounded-pill shadow-sm fs-6">
                {allMedit.length} {allMedit.length > 1 ? 'publications' : 'publication'}
            </span>
            <button className="btn btn-sm btn-outline-secondary rounded-circle" onClick={fetchAllMedit}><i className="bi bi-arrow-clockwise"></i></button>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-success" role="status"></div>
        </div>
      ) : (
        <div className="pinterest-grid px-3">
          {allMedit.map((m) => {
            const images = getImagesArray(m.linkImg);
            const carouselId = `carousel-pub-${m.idMedit}`;
            return (
                <div key={m.idMedit} className="pinterest-item pb-4">
                    <div className="card-custom border-0 shadow-sm overflow-hidden bg-white rounded-4 border w-100">
                        <div className="position-relative">
                            {images.length > 1 ? (
                                <div className="carousel-instagram" style={{ height: '300px' }}>
                                    <div className="carousel-inner-custom h-100" id={carouselId}>
                                        {images.map((img, idx) => (
                                            <div key={idx} className="carousel-slide-custom">
                                                <img src={img} alt={`img-${idx}`} className="w-100 h-100 object-cover" />
                                            </div>
                                        ))}
                                    </div>
                                    <button className="carousel-btn prev" onClick={(e) => { e.preventDefault(); handleScroll(carouselId, 'left'); }}>
                                        <i className="bi bi-chevron-left"></i>
                                    </button>
                                    <button className="carousel-btn next" onClick={(e) => { e.preventDefault(); handleScroll(carouselId, 'right'); }}>
                                        <i className="bi bi-chevron-right"></i>
                                    </button>
                                    <div className="carousel-dots-indicator">
                                        <span className="badge bg-dark bg-opacity-75 text-white extra-small rounded-pill px-2">
                                            <i className="bi bi-images me-1"></i> {images.length}
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                <img 
                                    src={images[0] || "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=500"} 
                                    className="w-100 d-block" 
                                    alt="méditation" 
                                    style={{ maxHeight: '400px', objectFit: 'cover' }}
                                />
                            )}
                            <div className="position-absolute top-0 start-0 m-2">
                                <span className="badge bg-success bg-opacity-75 text-white extra-small backdrop-blur">{m.type}</span>
                            </div>
                        </div>
                        
                        <div className="p-3">
                            <p className="text-dark small mb-3 lh-sm fw-medium white-space-pre-wrap text-break">
                                {m.textMedit || "Sans texte."}
                            </p>
                            
                            <div className="d-flex justify-content-between align-items-center pt-2 border-top border-light mb-1">
                                <span className="extra-small text-muted d-flex align-items-center gap-1">
                                    <i className="bi bi-share-fill"></i> {m.nbreShare} partages
                                </span>
                                <small className="text-muted extra-small">{new Date(m.datePublication).toLocaleDateString()}</small>
                            </div>

                            {m.commentaires && m.commentaires.length > 0 && (
                                <div className="mt-2 pt-2 border-top border-light overflow-hidden">
                                    <p className="fw-bold extra-small mb-1 text-primary">💬 {m.commentaires.length} Commentaires</p>
                                    <div className="d-flex flex-column gap-1 max-h-150 overflow-y-auto custom-scrollbar">
                                        {m.commentaires.map(c => (
                                            <div key={c.idCom} className="bg-light p-2 rounded-2" style={{fontSize: '0.7rem'}}>
                                                <div className="d-flex justify-content-between">
                                                    <span className="fw-bold text-dark text-truncate">{c.nomUser}</span>
                                                    <span className="text-muted">{new Date(c.dateCom).toLocaleDateString()}</span>
                                                </div>
                                                <p className="mb-0 text-muted lh-sm text-break">{c.contenu}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )
          })}
        </div>
      )}

      <style>{`
        .pinterest-grid { column-count: 3; column-gap: 1.5rem; width: 100%; max-width: 1600px; margin: 0 auto; box-sizing: border-box; }
        .pinterest-item { break-inside: avoid; display: block; width: 100%; }
        @media (max-width: 1100px) { .pinterest-grid { column-count: 2; } }
        @media (max-width: 700px) { .pinterest-grid { column-count: 1; } }

        .carousel-instagram { position: relative; overflow: hidden; }
        .carousel-inner-custom { display: flex; width: 100%; overflow-x: auto; scroll-snap-type: x mandatory; -ms-overflow-style: none; scrollbar-width: none; }
        .carousel-inner-custom::-webkit-scrollbar { display: none; }
        .carousel-slide-custom { flex: 0 0 100%; width: 100%; height: 100%; scroll-snap-align: start; }
        .carousel-slide-custom img { object-fit: cover; width: 100%; height: 100%; }
        
        .carousel-btn { position: absolute; top: 50%; transform: translateY(-50%); background: white; border: none; width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center; z-index: 10; cursor: pointer; box-shadow: 0 2px 6px rgba(0,0,0,0.2); }
        .carousel-btn.prev { left: 8px; }
        .carousel-btn.next { right: 8px; }
        
        .card-custom:hover { box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important; transform: translateY(-3px); transition: 0.3s; }
        .extra-small { font-size: 0.72rem; }
        .backdrop-blur { backdrop-filter: blur(4px); }
        .white-space-pre-wrap { white-space: pre-wrap; word-break: break-word; }
        .text-break { word-break: break-word; overflow-wrap: break-word; }
        .max-h-150 { max-height: 150px; }
        .custom-scrollbar::-webkit-scrollbar { width: 3px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #ddd; border-radius: 10px; }
      `}</style>
    </div>
  );
}

export default Publier;